import React, { useState } from "react";
import { Box, Button, Typography, TextField } from "@mui/material";
import BackspaceIcon from "@mui/icons-material/Backspace";
import ClockInButton from "components/ClockIn/ClockInButton";

const PinPad = ({ pin, setPin }) => {
  //   const [pin, setPin] = useState("");

  const handleButtonClick = (value) => {
    if (pin.length < 4) {
      setPin(pin + value);
    }
  };

  const handleBackspace = () => {
    setPin(pin.slice(0, -1));
  };

  const handleCancel = () => {
    setPin("");
  };
  console.log({ pin });
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      //   height="100vh"
    >
      <Typography variant="h5" gutterBottom>
        👋 Hi there
      </Typography>
      <Typography variant="body1" gutterBottom>
        Enter a four-digit employee PIN code
      </Typography>
      <Box display="flex" justifyContent="center" marginY={2}>
        {[...Array(4)].map((_, index) => (
          <TextField
            key={index}
            variant="outlined"
            value={pin[index] || ""}
            inputProps={{ readOnly: true }}
            style={{ width: "3rem", margin: "0 0.5rem" }}
            sx={{
              width: "3rem",
              margin: "0 0.5rem",
              "& .MuiInputBase-input": {
                color: "black",
                textAlign: "center",
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#ccc",
                },
                "&:hover fieldset": {
                  borderColor: "#999",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#666",
                },
              },
              backgroundColor: "#fff",
            }}
          />
        ))}
      </Box>
      <Box
        display="grid"
        gridTemplateColumns="repeat(3, 1fr)"
        gap={2}
        marginY={2}
      >
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, "", 0, ""].map((value, index) =>
          value === "" ? (
            <div key={index} />
          ) : value === "backspace" ? (
            <Button key={index} variant="outlined" onClick={handleBackspace}>
              <BackspaceIcon />
            </Button>
          ) : (
            // <ClockInButton
            //   key={index}
            //   variant="outlined"
            //   onClick={() => handleButtonClick(value)}
            // >
            //   {value}
            // </ClockInButton>
            <>
              <ClockInButton
                name={value}
                handleClick={() => {
                  return handleButtonClick(value);
                }}
              />
            </>
          )
        )}
      </Box>
      <Button variant="outlined" onClick={handleCancel}>
        Cancel
      </Button>
    </Box>
  );
};

export default PinPad;
